'use strict'

export const ICONS = {}
export const SEMANTIC_ICONS = {}
